import React, { useEffect } from 'react';
import { Marker, Popup } from 'react-map-gl';
import { useSelector, useDispatch } from 'react-redux';
import ListingCard, { ListingCardSkeleton } from '../Listings/Card';
import { listingSingleSearchPerformed as getListing } from '../../actions';

function UnselectedMarker({ longitude, latitude, onClickHandler }) {
  // const { highlightedMarker } = useSelector((state) => state.map);

  return (
    <Marker
      className="abc"
      longitude={longitude}
      latitude={latitude}
      offsetLeft={-13}
      offsetTop={-35}
      captureClick
    >
      <div onClick={onClickHandler} className="marker" />
    </Marker>
  );
}

function SelectedMarker({ longitude, latitude, id }) {
  const { cachedListings } = useSelector((state) => state.searchResults);

  return (
    <Popup
      latitude={latitude}
      longitude={longitude}
      closeButton={false}
      anchor="bottom"
      className="marker-card"
    >
      {
        cachedListings[id]
          ? (<ListingCard listing={cachedListings[id]} />)
          : (<ListingCardSkeleton />)
      }

    </Popup>
  );
}

let debounce;

export default function ListingMarker({ feature }) {
  const dispatch = useDispatch();
  const { id } = feature.properties;
  const { selectedMarker } = useSelector((state) => state.map);
  const [longitude, latitude] = feature.geometry.coordinates;

  useEffect(() => {
    dispatch(getListing(id));
  }, [selectedMarker]);

  return (
    id === selectedMarker
      ? (
        <SelectedMarker
          longitude={longitude}
          latitude={latitude}
          id={id}
        />
      )
      : (
        <UnselectedMarker
          longitude={longitude}
          latitude={latitude}
          onClickHandler={() => dispatch({ type: 'SELECT_MAP_MARKER', payload: id })}
        />
      )
  );
}
